import { createSelector } from 'reselect'

import { AppState } from './reducers'

export const getUi = (state: AppState) => state.ui
export const getData = (state: AppState) => state.data

export const getAssistantIsRequested = createSelector(
	getUi,
	ui => ui.assistantRequested,
)

export const getAssistantIsCalled = createSelector(
	getUi,
	ui => ui.assistantCalled,
)

export const getLocale = createSelector(
	getUi,
	ui => ui.locale,
)

export const getIsScanning = createSelector(
	getUi,
	ui => ui.scanPopupOpen,
)

export const getIsFetchingBarcodeResult = createSelector(
	getUi,
	ui => ui.fetchingBarcodeResult,
)

export const getProduct = createSelector(
	getData,
	data => data.product
)

export const getLocation = createSelector(
	getData,
	data => data.location
)

export const getPrice = createSelector(
	getData,
	data => data.price
)

export const getStocks = createSelector(
	getData,
	data => data.stocks
)

